export const STORE_ADMIN_EVENTS = 'adminEventsStore';
export const ADMIN_EVENTS_SET_OPTIONS = 'setOptions';
export const ADMIN_EVENTS_GET_DATA = 'getData';
export const ADMIN_EVENTS_UPDATE = 'updateEvent';
